import { render, staticRenderFns } from "./ClearProductsModal.vue?vue&type=template&id=408dc1b4"
import script from "./ClearProductsModal.vue?vue&type=script&lang=js"
export * from "./ClearProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports